import { useState } from "react";

import TextInput from "../../../../components/forms/textInput";
import Button from "../../../../components/common/button";

import "../../styles.css";
import { DialogModal } from "../../../../components/common/dialog";
import React from "react";

export enum ALERT {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  NONE = "NONE",
}

interface Props {
  showModal: boolean;
  onClose: () => void;
  onClickDone: (body) => Promise<void>;
}
const DeactiveModal = ({ showModal, onClose, onClickDone }: Props) => {
  const [inputValue, setInputValue] = useState("");

  const onModalClose = (withApiCall) => {
    if (withApiCall) {
      const body =
        inputValue.length == 0
          ? { active: false }
          : { active: false, deactivationReason: inputValue };
      onClickDone(body);
    }
    onClose();
  };

  return (
    <DialogModal
      open={showModal}
      handleClose={() => onModalClose(false)}
      title={" تعطيل الحساب"}>
      <div className={"container_modal"}>
        <TextInput
          label={"ادخل سبب لتعطيل الحساب"}
          required={false}
          handleChange={(e) => setInputValue(e.target.value)}
        />

        <Button onClick={() => onModalClose(true)}>حفظ</Button>
      </div>
    </DialogModal>
  );
};

export default DeactiveModal;
